module.exports = __webpack_public_path__ + "static/media/ppg-login-image.eb965368.jpg";